var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMarket = function SvgMarket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F6F8FB",
    width: 48,
    height: 48,
    rx: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9h30v30H9z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#686F81",
    strokeWidth: 2.4,
    x: 13.2,
    y: 13.2,
    width: 21.6,
    height: 17.6,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.57 24.735c.424.37 1.054.375 1.482.009l4.703-4.016c.478-.408.537-1.13.13-1.61a1.132 1.132 0 0 0-1.601-.132l-3.958 3.38-2.748-2.404a1.131 1.131 0 0 0-1.43-.05l-4.016 3.049c-.501.38-.6 1.097-.223 1.6.379.504 1.091.604 1.592.224l3.28-2.49 2.79 2.44Z",
    fill: "#686F81"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#686F81",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    d: "M18.5 35.5h11"
  }))));
};
export default SvgMarket;